import { SectionLabel } from "./Disciplines";

const steps = [
  { n: "I", title: "Manipular", desc: "Toma el objeto. Desármalo. Conoce su peso, su tacto, su resistencia. El conocimiento empieza en las manos." },
  { n: "II", title: "Analizar", desc: "Identifica sus partes, funciones y principios. ¿Qué ley física, química o matemática lo gobierna?" },
  { n: "III", title: "Investigar", desc: "Busca su historia. ¿Quién lo creó? ¿Qué problema resolvía? ¿Qué intentos previos fracasaron?" },
  { n: "IV", title: "Inventar", desc: "Imagina lo que aún no existe. Cruza disciplinas. Diseña con intención y rigor." },
  { n: "V", title: "Reinventar", desc: "Toma lo que existe y mejóralo. Hazlo más simple, más eficiente, más humano, más sostenible." },
];

export const Method = () => (
  <section id="metodo" className="relative py-32 border-t border-border bg-void">
    <div className="container max-w-5xl">
      <SectionLabel index="05" title="Método" />
      <h2 className="font-serif-display text-4xl md:text-6xl font-light mb-6 leading-tight">
        Cinco verbos. <span className="text-ember italic">Una vida entera.</span>
      </h2>
      <p className="text-muted-foreground max-w-2xl mb-20 leading-relaxed">
        El método Prometheus no es una receta: es un ritual. Repetido, refinado, encarnado.
      </p>

      <ol className="relative space-y-px">
        {steps.map((s, i) => (
          <li
            key={s.n}
            className="group grid grid-cols-[80px_1fr] md:grid-cols-[120px_200px_1fr] gap-6 md:gap-10 py-8 border-t border-border hover:bg-card/50 transition-colors duration-500 px-2"
          >
            <div className="font-serif-display text-5xl md:text-7xl text-ember leading-none">{s.n}</div>
            <h3 className="font-serif-display text-2xl md:text-3xl self-center">{s.title}</h3>
            <p className="text-muted-foreground self-center leading-relaxed col-span-2 md:col-span-1">{s.desc}</p>
          </li>
        ))}
        <li className="border-t border-border" />
      </ol>
    </div>
  </section>
);